import { cookies } from 'sharedKernel/cookies/behavior'

export class CaixaUser {
  private static instance: CaixaUser

  public static getInstance(): CaixaUser {
    if (!CaixaUser.instance) {
      CaixaUser.instance = new CaixaUser()
    }
    return CaixaUser.instance
  }

  public isCaixaUser(): boolean {
    try {
      const userData = cookies.get('_cred')?.data
      const permissions = cookies.get('_perm')?.features
      
      if (userData?.role?.name === 'CaixaEmployee') {
        return true
      }
      
      if (permissions?.some(feature => feature.code === 'caixa_employee')) {
        return true
      }
      
      return false
    } catch (error) {
      console.error('Error checking Caixa user:', error)

      return false
    }
  }

  public getCaixaUserEmail(): string | null {
    try {
      const userData = cookies.get('_cred')?.data
      const userEmail = userData?.email
      
      return userEmail || null
    } catch (error) {
      console.error('Error getting Caixa user email:', error)
      return null
    }
  }

  public hasPermission(permission: string, access?: string): boolean {
    try {
      if (this.isCaixaUser()) {
        const allowedPermissions = ['idea', 'evaluation', 'caixa_employee']
        if (allowedPermissions.includes(permission)) {
          return true
        }
      }
      
      const permissions = cookies.get('_perm')?.features
      if (!permissions) return false
      
      const feature = permissions.find(f => f.code === permission)
      if (!feature) return false
      
      if (!access) return true
      
      return feature.access?.some(a => a.code === access) ?? false
    } catch (error) {
      console.error('Error checking permission:', error)
      return false
    }
  }
}

export const caixaUser = CaixaUser.getInstance()
